import PropTypes from 'prop-types';
import React from 'react';

import Theme from 'styles/theme';

import Overview from './Overview';
import SwatchList from './SwatchList';

const PdpProductSelectorSection = ({
  label,
  currentProductLabel,
  currentProductName,
  products,
  compareAtPrice,
  price,
  isSalePdp,
  ...otherProps
}) => (
  <div className="PdpProductSelectorSection">
    <Overview
      label={label}
      price={price}
      compareAtPrice={compareAtPrice}
      name={currentProductLabel === label ? currentProductName : ''}
      isSalePdp={isSalePdp}
    />
    <SwatchList swatchAngle={135} {...otherProps} products={products} />
    <style jsx>
      {`
        .PdpProductSelectorSection {
          margin-bottom: ${Theme.get('spacing') * 2.5}px;
        }

        .PdpProductSelectorSection:last-child {
          margin-bottom: 0;
        }
      `}
    </style>
  </div>
);

PdpProductSelectorSection.propTypes = {
  products: PropTypes.arrayOf(PropTypes.shape({})),
  onSelect: PropTypes.func.isRequired,
  currentProductLabel: PropTypes.string,
  currentProductName: PropTypes.string,
  currentProductHandle: PropTypes.string,
  label: PropTypes.string,
  isLoading: PropTypes.bool,
  compareAtPrice: PropTypes.string,
  price: PropTypes.string,
  isSalePdp: PropTypes.bool.isRequired,
};

PdpProductSelectorSection.defaultProps = {
  products: [],
  currentProductLabel: null,
  currentProductName: null,
  currentProductHandle: null,
  label: null,
  isLoading: false,
  compareAtPrice: null,
  price: null,
};

export default PdpProductSelectorSection;
